import { lazy, Suspense, FC } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

import { PdpSharedDealerDetailsBioModalLazy_seller as Seller } from './__generated__/PdpSharedDealerDetailsBioModalLazy_seller.graphql';

const LazyComponent = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedDealerDetailsBioModal" */ './PdpSharedDealerDetailsBioModal'
        )
);

type Props = {
    seller: Seller;
    linkClass?: string;
};

export const PdpSharedDealerDetailsBioModalLazyComponent: FC<Props> = props => (
    <Suspense fallback={null}>
        <LazyComponent {...props} />
    </Suspense>
);

export const PdpSharedDealerDetailsBioModalLazy = createFragmentContainer(
    PdpSharedDealerDetailsBioModalLazyComponent,
    {
        seller: graphql`
            fragment PdpSharedDealerDetailsBioModalLazy_seller on Seller {
                ...PdpSharedDealerDetailsBioModal_seller
            }
        `,
    }
);
